export default {
  最多填写10个纯数字: '最多填写10个纯数字',
  '纯数字,最多填写3位数字': '纯数字,最多填写3位数字',
  标签只可以输出六个字以内: '标签只可以输出六个字以内',
  自定义标签最多20个: '自定义标签最多20个',
  请输入手机号码: '请输入手机号码',
  加入成功: '申请成功,请等待企业审核',
  公司名重复: '公司名重复',
  '图片格式为JPG/PNG,分辨率1920*430,大小不能超过10M': '图片格式为JPG/PNG,分辨率1920*430,大小不能超过10M',
  '图片格式为JPG/PNG,分辨率800*500,大小不能超过5M': '图片格式为JPG/PNG,分辨率800*500,大小不能超过5M',
  '图片格式为JPG/PNG,分辨率480*270,大小不能超过5M': '图片格式为JPG/PNG,分辨率480*270,大小不能超过5M',
}
